import React, { useState } from "react";
import Repeatability_table from "./repeatability_table/Repeatability_table";
import Repeatability_Form from "./repeatability_Form/Repeatability_Form";

function Repeatability() {
  const [showTable, setShowTable] = useState(false);

  return (
    <>
      <div className="imperiality_Form_div">
        <Repeatability_Form onProceed={() => setShowTable(true)} />
      </div>

      {showTable && (
        <div className="imperiality_table_div">
          <Repeatability_table/>
        </div>
      )}
    </>
  );
}

export default Repeatability;
